
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
name: "srvprepairinfo",
components: {Cell, Group, XHeader},
data() {
return {
info: this.$route.params.info
}
}
}



// WEBPACK FOOTER //
// ./src/components/Indvrepair/srvprepairinfo.vue